__turbopack_context__.v({
  "highlighted": "CalendarLegend-module-scss-module__Zb5AGa__highlighted",
  "legend": "CalendarLegend-module-scss-module__Zb5AGa__legend",
  "legendItem": "CalendarLegend-module-scss-module__Zb5AGa__legendItem",
  "marker": "CalendarLegend-module-scss-module__Zb5AGa__marker",
  "selected": "CalendarLegend-module-scss-module__Zb5AGa__selected",
  "today": "CalendarLegend-module-scss-module__Zb5AGa__today",
});
